import { configureStore, Tuple } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import middleware from '@app/store/middleware';
import appReducer from '@shared/redux/reducers';
import rootSaga from '@shared/redux/sagas';
import { formActionSaga } from '@shared/util/createFormAction';
import { reportError } from '@shared/util/sentry';

const sagaMiddleware = createSagaMiddleware({
  onError(error) {
    const message = error.stack || error.toString();
    // eslint-disable-next-line no-console
    console.error(message);
    reportError(error);
  },
});

export default function initConfiguration() {
  const store = configureStore({
    reducer: appReducer(),
    middleware: () => new Tuple(...middleware, sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });

  sagaMiddleware.run(rootSaga);
  sagaMiddleware.run(formActionSaga);

  return { store };
}

export type AppStore = ReturnType<typeof initConfiguration>['store'];
export type AppDispatch = AppStore['dispatch'];
